import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { Checkbox } from "../../../Checkbox/Checkbox";
import { defaultPropObject } from "../../../constants";
import { useMediaQuery } from "../../../hooks";
import { CheckCircleFilled, CheckLinear } from "../../../icons";
import { ListIcon, ListItem } from "../../List";
import { TextBase } from "../../TextBase";
import styles from "./DropListItem.css";
var cx = classNames.bind(styles);
var checkedIcons = {
  mobile: function mobile(iconClass) {
    return /*#__PURE__*/React.createElement(ListIcon, {
      classes: {
        root: iconClass
      },
      position: "right-end"
    }, /*#__PURE__*/React.createElement(CheckCircleFilled, null));
  },
  desktop: function desktop() {
    return /*#__PURE__*/React.createElement(ListIcon, {
      position: "right-end"
    }, /*#__PURE__*/React.createElement(CheckLinear, null));
  }
};
export var DropListItem = function DropListItem(_ref) {
  var Component = _ref.as,
      item = _ref.item,
      isSelected = _ref.isSelected,
      multiple = _ref.multiple,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      onChange = _ref.onChange,
      theme = _ref.theme,
      icon = _ref.icon,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes;
  var breakpoints = useMediaQuery('xs');
  var isMobile = breakpoints.xs;
  var isShowMobileCheckedIcon = isSelected && isMobile;
  var isShowDesktopCheckedIcon = isSelected && !multiple && !isMobile;
  return /*#__PURE__*/React.createElement(ListItem, _extends({
    view: isMobile ? 'mobile' : 'desktop',
    role: "option",
    "aria-selected": isSelected ? true : undefined,
    onClick: onClick,
    onKeyDown: onKeyDown
  }, multiple && !isMobile ? {} : {
    tabIndex: 0
  }), multiple && !isMobile && /*#__PURE__*/React.createElement("span", {
    className: cx('checkbox')
  }, /*#__PURE__*/React.createElement(Checkbox, {
    disabled: item.disabled,
    checked: isSelected,
    theme: theme,
    onChange: onChange
  })), icon && /*#__PURE__*/React.createElement(ListIcon, {
    position: "left"
  }, icon), Component ? /*#__PURE__*/React.createElement(Component, item) : /*#__PURE__*/React.createElement(TextBase, {
    noWrap: true,
    color: item.disabled ? 'N100' : 'inherit'
  }, item.label), isShowDesktopCheckedIcon && checkedIcons.desktop(), isShowMobileCheckedIcon && checkedIcons.mobile(classes.mobileCheckIcon));
};